import { TableColumnMeta } from "ds/components/Table/types";

export enum ContextColumnId {
  NAME = "name",
  DESCRIPTION = "description",
}

export const CONTEXTS_COLUMNS: Record<ContextColumnId, TableColumnMeta> = {
  [ContextColumnId.NAME]: {
    id: ContextColumnId.NAME,
    title: "Name",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
  [ContextColumnId.DESCRIPTION]: {
    id: ContextColumnId.DESCRIPTION,
    title: "Description",
    defaultWidth: 150,
    minWidth: 150,
    maxWidth: 300,
    allowsSorting: false,
    resizable: false,
  },
};
